import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  section: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 170px)',
    padding: '48px 24px',
    textAlign: 'center',
    [Theme.breakpoints.down('sm')]: {
      padding: '32px 20px',
    },
  },
  icon: {
    height: 64,
    marginBottom: 24,
    width: 64,
    '& path': {
      fill: Theme.palette.primary.main,
    },
  },
  title: {
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[9],
    lineHeight: '150%',
    marginBottom: 16,
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[7],
    },
    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[6],
    },
  },
  description: {
    color: Theme.palette.gray[750],
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[3],
    fontWeight: 400,
    lineHeight: '150%',
    marginBottom: 12,
    maxWidth: 640,
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[2],
    },
  },
}));

export default useStyles;
